<div class="desktop-view">
  <div class="tab-parent">
    <!-- sequenceVersionDate: {{entryData().sequenceVersionDate.split('T')[0]}}<br />
    uniprot sequence.modified : {{uniprotData().sequence.modified}}  -->
    <section *ngIf="isOldUniprotEntry">
        <notification-msg 
            [type]="'warning'" 
            [message]="'This AlphaFold model was generated using a prior version of the UniProt sequence.'">
        </notification-msg>
    </section>
    <section class="domain-info" *ngIf="summaryTexts.length > 0">
      <div *ngFor="let group of summaryTexts let isLast = last" class="domain-info-grouped">
        <div class="info-row" *ngFor="let item of group">
          <span *ngIf="item.label !== 'Average pLDDT'">
            {{ item.label }}
          </span>
  
          <span  *ngIf="item.source && item.source === 'tooltip' && item.label === 'Average pLDDT'">
            {{ item.label }}<help-icon-with-tooltip style="margin-left: 4px;" [tooltipText]="'Mean pLDDT score for residues across the full-length protein. Indicates AlphaFold confidence.'" [isOnlytext]="false" />
          </span>
          <ng-container>
            <article>
              <span *ngIf="item.label != 'Status'">
                <span *ngIf="item.show_long">
                  <span [innerHTML]="item.text"></span>
                  <a
                    *ngIf="getShortenedText(item.text) != item.text"
                    class="vf-link"
                    (click)="switchText(item)"
                  >
                    <i class="icon icon-functional"></i> Show less
                  </a>
                </span>
                <span *ngIf="!item.show_long">
                  <span [innerHTML]="getShortenedText(item.text)"></span>
                  <a
                    class="vf-link"
                    *ngIf="checkIfHasToShowMore(item)"
                    (click)="switchText(item)"
                  >
                    <i class="icon icon-functional"></i> Show more
                  </a>
                </span>
              </span>
    
              <a
                *ngIf="item.source && item.source !== 'tooltip'"
                target="_blank"
                href="{{ item.source_url }}"
                class="vf-link ext"
              >
                go to {{ item.source }}</a
              >
            
              <span *ngIf="item.italic"
                ><a
                  class="vf-link ext"
                  href="./search/organismScientificName/{{
                    commonService.escapeValue(item.searchText)
                  }}"
                  target="_blank"
                  >go to search</a
                ></span
              >
            </article>
          </ng-container>
        </div>
        <div class="info-row plddt-summary" *ngIf="isLast && plddtData">
          <span>pLDDT distribution</span>
          <article style="display:flex; flex-direction: row;">
            <div>
              <div class="plddtlegends">
                <span class="legendColor" style="background-color: #0053d6;">&nbsp;</span>
                {{ (plddtData?.fractionPlddtVeryHigh * 100) | number : '1.0-1' }}% Very high
              </div>
              <div class="plddtlegends">
                <span class="legendColor" style="background-color: #65cbf3;">&nbsp;</span>
                {{ (plddtData?.fractionPlddtConfident * 100) | number : '1.0-1' }}% High
              </div>
              <div class="plddtlegends">
                <span class="legendColor" style="background-color: #ffdb13;">&nbsp;</span>
                {{ (plddtData?.fractionPlddtLow * 100) | number : '1.0-1' }}% Low
              </div>
              <div class="plddtlegends">
                <span class="legendColor" style="background-color: #ff7d45;">&nbsp;</span>
                {{ (plddtData?.fractionPlddtVeryLow * 100) | number : '1.0-1' }}% Very low
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  
    <section class="domain-info-loader" *ngIf="summaryTexts.length === 0">
      <div style="text-align: center; margin: 90px 0">
        <img src="../../assets/img/loader.gif" width="30px" />
      </div>
    </section>
   
    <!-- <section>
      <div class="more-info" *ngIf="otherOrganismScientificNames && otherOrganismScientificNames.text.length">
        This exact same sequence is also present in {{otherOrganismScientificNames.totalCount}} species: 
        <span>
          <span *ngIf="otherOrganismScientificNames.show_long">
            <i><span [innerHTML]="otherOrganismScientificNames.text"></span></i>
            <a
              *ngIf="getShortenedOrganismNames(otherOrganismScientificNames.text) != otherOrganismScientificNames.text"
              class="vf-link"
              (click)="switchText(otherOrganismScientificNames)"
            >
              <i class="icon icon-functional"></i> Show less
            </a>
          </span>
          <span *ngIf="!otherOrganismScientificNames.show_long">
            <i><span [innerHTML]="getShortenedOrganismNames(otherOrganismScientificNames.text)"></span></i>
            <a
              class="vf-link"
              *ngIf="checkOrganismHasToShowMore(otherOrganismScientificNames)"
              (click)="switchText(otherOrganismScientificNames)"
            >
              <i class="icon icon-functional"></i> Show more
            </a>
          </span>
          <span>
            &nbsp;&nbsp;<a class="vf-link" href="#">
              <i class="icon icon-functional"></i>Learn more...
            </a>
          </span>
        </span>
      </div>
    </section> -->

    <section>
      <div class="sequence-container">
        <div class="title">
          <span class="text"> {{entryData().uniprotDescription ? entryData().uniprotDescription : 'Not named'}}, Sequence length {{ (entryData().sequenceEnd - entryData().sequenceStart) + 1 }} </span>
          <div class="label-tooltip-seq" style="display: inline">
            <span *ngIf="isCopySequence" class="label-tooltip-seq-text">
              Sequence copied
            </span>
            <button (click)="copySequence(entryData().sequence)">Copy sequence</button>
          </div>
        </div>
        <!-- <div class="sequence">
          <span> {{entryData().sequence}} </span>
        </div> -->

        <div class="summary-sequencepanel"></div>
      </div>

     
    </section>
    
    <section>
      <div class="structure-container" *ngIf="hydrationReady">
   
        <app-pae-view
        *ngIf="entryData().paeDocUrl"
       
        [paeid]="'summary-paeviewer'"
        (selectedRegion)="cmSelectionUpdate($event)"
        [isMobilePae]="false"
        (click)="
          gaService.eventEmitter(
            'pae-click',
            'pae',
            'click',
            accession(),
            undefined
          )
          "
        >
        </app-pae-view>
    
        <div class="molstarView">
          <div
            class="summary-molstar-container"
          ></div>
        </div>
        <section class="legends-controls">
          <app-legends-panel (toggleAccordion)="toggleAccordion($event)" [tedDomainData]="tedDomainData()" [csvAmData]="csvAmData()"></app-legends-panel>
          <div class="audit-container">
            <span class="audit-info"><b>Audit history </b></span>
            <span class="audit-info"><b>Model creation date:</b> <span class="infodate"> {{ entryData()?.modelCreatedDate | date: 'd MMM y' }}</span>
              <help-icon-with-tooltip [tooltipText]="'Date when the AlphaFold model for this entry was predicted.'" [isOnlytext]="false" />
            </span>

            <span class="audit-info" *ngIf="entryData().isUniProt"><b>Sequence version date:</b> <span class="infodate"> {{ uniprotData()?.sequence?.modified | date: 'd MMM y' }}</span>
              <help-icon-with-tooltip [tooltipText]="'The release date of the amino acid sequence from UniProt used to generate this model.'" [isOnlytext]="false" />
            </span>
          </div>
        </section>
  
      </div>
    </section>
    <div class="sectionContent"></div>
    <section class="publication-container">
      <div class="publication-title">
        Dataset publication
      </div>
      <div class="publication-desc">
        <a href="{{(providerData().citations && providerData().citations[0]) ?  providerData().citations[0].url : '#'}}" class="public-link"> {{(providerData().citations && providerData().citations[0]) ?  providerData().citations[0].description : ""}}</a>
      </div>
    </section>
  </div>
</div>
